<template>
  <div>
    <div class="info-title">
      <span>报警信息</span>
    </div>
    <div class="info-wrapper">
      <div class='no-err-site' v-if="errSite.length === 0">
        未发现报警网站
      </div>
      <div class='err-site' v-for="(item,index) of errSite" :key='index'>
        <div class='site-name'>
          <span>{{item.name}}</span>
        </div>
        <div class='line'></div>
        <div class='site-item'>
          <div>
            <span>网站地址:</span>
            <span>{{item.address}}</span>
          </div>
          <div v-if="item.resCode !== '200'">
            <span>响应码:</span>
            <span>{{item.resCode}}</span>
          </div>
          <div>
            <span>响应速度:</span>
            <span>{{item.resTime}}</span>
          </div>
        </div>
      </div>
      <div class='no-err-server' v-if="errServer.length === 0">
        未发现报警服务器
      </div>
      <div class='err-server' v-for="(item,index) of errServer" :key='index'>
        <div class='server-name'>
          <span>{{item.name}}</span>
        </div>
        <div class='line'></div>
        <div class='server-item'>
          <div>
            <span>服务器地址:</span>
            <span>{{item.host}}</span>
          </div>
          <div v-if='parseFloat(item.cpuUsage)>=cpuErrorValue'>
            <span>cpu使用率:</span>
            <span>{{item.cpuUsage}}</span>
          </div>
          <div v-if="parseFloat(item.memUsage)>=memErrorValue">
            <span>内存使用率:</span>
            <span>{{item.memUsage}}</span>
          </div>
        </div>
      </div>
      <div class='no-err-mysql' v-if="errMysql.length === 0">
        未发现报警mysql
      </div>
      <div class='err-mysql' v-for="(item,index) of errMysql" :key='index'>
        <div class='mysql-name'>
          <span>{{item.name}}</span>
        </div>
        <div class='line'></div>
        <div class='mysql-item'>
          <div>
            <span>服务器地址:</span>
            <span>{{item.host}}</span>
          </div>
          <div>
            <span>状态:</span>
            <span>{{item.err}}</span>
          </div>
        </div>
      </div>
      <div class='no-err-mongo' v-if="errMongo.length === 0">
        未发现报警mongo
      </div>
      <div class='err-mongo' v-for="(item,index) of errMongo" :key='index'>
        <div class='mongo-name'>
          <span>{{item.name}}</span>
        </div>
        <div class='line'></div>
        <div class='mongo-item'>
          <div>
            <span>服务器地址:</span>
            <span>{{item.host}}</span>
          </div>
          <div>
            <span>状态:</span>
            <span>{{item.err}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  
  export default {
    data() {
      return {
        cpuErrorValue:70,
        memErrorValue:90,
        errSite:[],
        errServer:[],
        errMysql:[],
        errMongo: []
      };
    },
    mounted() {
      this.getSite();
      this.getServer();
    },
    methods: {
      getSite() {
        var _this=this
        axios.get(process.env.baseURL + 'getSite')
        .then(function(res){
          _this.errSite = []
          for(var site of res.data.data) {
            if(site.status === '严重') {
              _this.errSite.push({name:site.name,address:site.address,resCode:site.resCode,resTime:site.resTime})
            }
            if(site.status2 === '严重'){
              _this.errSite.push({name:site.name,address:site.address2,resCode:site.resCode2,resTime:site.resTime2})
            }
          }
          console.log('this.errSite :>> ', _this.errSite);
        })
      },
      getServer() {
        var _this =this
        axios.get(process.env.baseURL + 'getServer')
        .then(function(res){
          console.log('res :>> ', res);
          _this.errServer = []
          _this.errMongo = []
          for(var server of res.data.data) {
            if(parseFloat(server.cpuUsage)>=_this.cpuErrorValue || parseFloat(server.memUsage)>=_this.memErrorValue) {
              _this.errServer.push({name:server.name,host:server.host,cpuUsage:server.cpuUsage,memUsage:server.memUsage})
            }
            if(server.mysqlCon === '断线') {
              _this.errMysql.push({name:server.name,host:server.host,err:'断线'})
            }
            if(server.mongoCon === '断线') {
              _this.errMongo.push({name:server.name,host:server.host,err:'断线'})
            }
          }
          console.log('this.errServer :>> ', _this.errServer);
        })
      }
    }
  };
</script>
<style lang="less" scoped>
  .info-title {
    text-align: center;
    span {
      display: inline-block;
      text-align: center;
      color: #fff;
      width: 80vw;
      font-size: 24px;
    }
    padding: 5px 0;
    margin-bottom: 2vh;
    line-height: 5vh;
  }

  .info-wrapper{
    display: flex;
    width: 90%;
    margin: 0 auto;
    top: 0;
    left: 0;
    flex-direction: column;
    align-items: center;
    padding-top: 60px;
    padding-bottom: 25px;
    .no-err-site,.no-err-server,.no-err-mysql,.no-err-mongo {
      width: 100%;
      height: 60px;
      margin: 0 1vw 1vh 0;
      text-align:center;
      font-size: 24px;
      line-height:60px;
      color:#fff;
    }
    .err-site,.err-server,.err-mysql,.err-mongo{
      width: 100%;
      height: 120px;
      margin: 0 1vw 1vh 0;
      background: linear-gradient(to top right, #965252 20%, #5c3938 80%);
      border-radius: 7px;
      padding: 10px 2vw;
      line-height: 14px;
      text-align: left;
      font-size: 14px;
      position: relative;
      overflow: hidden;
      .site-name,.server-name,.mysql-name,.mongo-name {
        text-align: left;
        width: 80%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .line {
        width: 80%;
        height: 2px;
        background: rgb(24, 30, 38, 0.4);
        position: absolute;
        top: 32px;
        left: 0;
      }
      .site-item,.server-item,.mysql-item,.mongo-item {
        width: 100%;
        height: 80%;
        overflow: hidden;
        position: relative;
        top: 5%;
        div {
          margin-top: 12px;
          font-size: 13px;
          width: 100%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
     }
  }

  
</style>


// WEBPACK FOOTER //
// src/pages/reportmessage.vue